import * as _ from 'lodash';

export interface IUser {
   uid: string;
   account: string;
   displayname: string;
   lastname: string;
   firstname: string;
   email: string;
   _key: string;
}

export class User implements IUser {

   // new + clone
   static NEW_NULL_OBJECT = new User(
      '',               // uid
      '',               // account
      '',               // displayname
      '',               // lastname
      '',               // firstname
      '',               // email
      null              // _key
   );
   static getNewObject(): User { return _.cloneDeep(User.NEW_NULL_OBJECT); }
   static getClone(user: User): User { return _.cloneDeep(user); }

   // json mapper
   static jsObjToClass({
      uid,
      account,
      displayname,
      lastname,
      firstname,
      email,
      _key
   }): User {
      return new User(
         uid,
         account,
         displayname,
         lastname,
         firstname,
         email,
         _key
      );
   }

   constructor(
      public uid: string,
      public account: string,
      public displayname: string,
      public lastname: string,
      public firstname: string,
      public email: string,
      public _key: string
   ) { }

   // public interface
   isVirgin() { return this.uid.length === 0; }
   isLoggedIn(): boolean {
      return (this.uid.length > 0);
   }


}



// WEBPACK FOOTER //
// /builds/cp/frap/t3/planer/src/app/user/model/user.ts